export default {
     syssetting: '/api/app',
     login: '/api/login_pc',                      // 登录
     register: '/api/register',                   // 注册
     getAgentLoginUrl: '/api/getAgentLoginUrl',   // 代理地址

     usrInf: '/api/user',                         // 用户信息
     usrVip: '/api/uservip',                      // 用户VIP
     setName: '/api/setName',                     // 设置用户名
     lockAmount: '/api/lockAmount',               // 金额锁定
     editPayPassword: '/api/editPayPassword',     // 修改支付密码

     userBonus: '/api/userBonus',
     doUserBonus: '/api/doUserBonus',

     dorecharge: '/api/recharge',                 // 充值

     getBank: '/api/gerBankInfo',                 // 获取银行卡
     getWallet: '/api/gerWalletInfo',             // 获取钱包 
     SysBank: '/api/gerSysBankInfo',              // 银行  
     bindCard: '/api/bindCard',                   // 绑定银行卡
     bindWallet: '/api/bindWallet',               // 绑定钱包

     rechargetype : '/api/gerRechargeType',       // 支付类型
     rechargeaisle : '/api/gerRechargeAisle',     // 支付通道
     withdrawtype: '/api/gerWithdrawType',        // 提现通道
     dowithdraw: '/api/withdraw',

     getbalance: '/api/balance',                  // 获取余额
     usrStats: '/api/userStats',                  // 用户状态
     usrnotice: '/api/noticeList',                // 用户通知
     dotransall: '/api/transall',                 // 一键回收
     balanCelist: '/api/balancelist',             // 游戏账户

     transrecord: '/api/gettransrecord',          // 流水记录（存取转入转出）
     usrBetrecord: '/api/betrecord',              // 用户投注记录
     fanshui: '/api/getfanshui',                  // 用户反水
     getFlow: '/api/getTaskFlow',                 // 用户奖金
     getFanShui: '/api/dofanshui',                // 领取反水
     
     noticeInfo: '/api/noticeInfo',               // 通知详情
     getCustomer: '/api/getKefu',                 // 获取客服

     noticeList: '/api/homenotice',               // 通知
     bannerlst: '/api/bannerList',                // 首页banner
     gameType: '/api/gameType',                   // 首页游戏分类
     //indexhot: '/api/hot_index',                // 热门
     indexhot: '/api/gameIsHot',                  // 热门
     //categoryEntry: '/api/categoryEntry',       // 根据类型获取游戏
     categoryEntry: '/api/gameLobbyAll',          // 根据类型获取游戏
     getGame: '/api/getGameUrl',                  // 获取游戏路径

     activitytype: '/api/activitytype',           // 活动类型
     activitylist: '/api/activitylist',           // 活动列表
     activitydeatil: '/api/activitydeatil',       // 活动详情

     taskType: '/api/taskType',                   // 任务类型
     usrTask: '/api/userTask',                    // 用户任务
     claimTask: '/api/claimTask',                 // 领取任务

     usrBox: '/api/userBox',                      // 用户盒子
     doUsrBox: '/api/doUserBox',                  // 打开盒子

     getUserFanshuiInfo: '/api/agent/getUserFanshuiInfo',   // 外水信息
     claimOutFanshui: '/api/agent/claimOutFanshui',         // 领取外水
     claimLogs: '/api/agent/claimLogs',                     // 外水领取记录
     getFanshuiSummary: '/api/agent/getFanshuiSummary',     // 反水信息
     claimFanshui: '/api/agent/claimFanshui',               // 领取反水
     fansClaimLogs: '/api/agent/fansClaimLogs',             // 反水领取记录
     getRegionFanshuiInfo: "/api/agent/getRegionFanshuiInfo",    //获取大区反水信息
     getClaimRegionFanshui: '/api/agent/claimRegionFanshui',// 领取大区反水
     regionClaimLogs: '/api/agent/regionClaimLogs',    // 大区返水领取记录
     setAgentRegionFanshuiFee: '/api/agent/setAgentRegionFanshuiFee',//设置大区

     AgentReportSummary: '/api/agent/getAgentReportSummary',// 获取团队信息以及报表
     AgentTeamList: '/api/agent/getAgentTeamList',// 获取团队信息以及报表
     AgentFanshuiFee: '/api/agent/setAgentFanshuiFee', //设置会员反水比例

     FriendLink: '/api/friend-links',              //友商
     FindPwd: '/api/forgetPayPassword',           //找回支付密码

     WheelConfig: '/api/wheel/config',       // 转盘配置
     WheelSpin: '/api/wheel/spin',           // 转盘抽奖
     WheelRecord: '/api/wheel/records',      // 抽奖记录
}
